module.exports = __webpack_public_path__ + "static/media/furvac360-3.1a0e5f73.jpg";